export default __webpack_public_path__ + "static/media/solem8sguywithlogo.956299bc.png";